import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import isAuthenticated from "./components/auth/auth";
import AOS from "aos";

// Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

//auth componentss
// import GotCode from './components/auth/GotCode';
import CleverAuth from "./components/auth/CleverAuth";
import FullRegister from "./components/auth/FullRegister";
import EmailVerification from "./components/auth/EmailVerification";
// import CodeRegister from './components/auth/CodeRegsiter'
// import RequestCode from './components/auth/RequestCode'
import ResetPassword from "./components/auth/ResetPassword";
import Login from "./components/auth/Login";

//Home Screens
// import Module from './components/home/Module'
//Profile components
import Profile from "./components/profile/Profile";

//splash screens
import GetStarted from "./components/splash-screen/GetStarted";
import Splash2 from "./components/splash-screen/Splash2";
import Wellcome from "./components/splash-screen/Wellcome";
import LearnMore from "./components/splash-screen/LearnMore";

//Other
import HelpDesk from "./components/other/HelpDesk";
import TurnPhoneV from "./components/other/TurnPhoneV";
import TurnPhoneH from "./components/other/TurnPhoneH";
import PrivacyPolicy from "./components/other/PrivacyPolicy";
import SuccessSkillsIntro from "./components/other/SuccessSkillIntro";
import SuccessSkillForm from "./components/other/SuccessSkillForm";
import SuccessSkillSearch from "./components/other/SuccessSkillSearch";
import SuccessSkillList from "./components/other/SuccessSkillList";
import SuccessSkillDetails from "./components/other/SuccessSkillDetails";
import Error from "./components/other/Error";
import CustomerSupport from "./components/other/CustomerSupport";
import NotFound from "./components/other/404";

//modules
import BusinessFoundation from "./components/modules/BusinessFoundation";
import Modules from "./components/modules/Modules";

//lessons
import WordsCape from "./components/wordle-game/WordsCape";
import AltSpaceVR from "./components/lessons/AltSpaceVR";
import AltSpaceVRWS from "./components/lessons/AltSpaceVRWS";
import Lesson from "./components/lessons/Lesson";
import Skills from "./components/lessons/skills/Skills";
import SkillsDetails from "./components/lessons/skills/SkillsDetails";
import SkillAssess from "./components/lessons/skills/SkillAssess";
import SkillSims from "./components/lessons/skills/SkillSims";
import SkillQuiz from "./components/lessons/skills/SkillQuiz";
import QuizResult from "./components/lessons/results/QuizResult";
import Rewards from "./components/lessons/results/Rewards";
import Loading from "./components/common/Loading";
import Subskills from "./components/lessons/skills/Subskills";

import ChatBot from "./components/chatbot/index";
import Video from "./components/video/index";
import Planner from "./components/planner";

//react-query modules  and functions
import { useQuery, useMutation, useQueryClient } from "react-query";
import {
  getAllData,
  getJobs,
  newEnrollment,
  adminEnrolledData,
  getOrganizations,
} from "./components/_api/index";
import { getNotifications } from './components/_api/getNotifications'

import {
  setData,
  setLoading,
  setOrganization,
  setNotifications
} from "./redux-features/user/userSlice";
import { setJobData, setDataFetch } from "./redux-features/job/JobSlice";
import { useDispatch, useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import PreviewCheck from "./components/home/PreviewCheck";

import Sticky from "./components/sticky/Sticky";
import StickyDemo from "./components/sticky/StickyDemo";

import Tutorial from "./components/common/page-tutorials";
import { Avatar } from "@mui/material";
import { useTranslation } from "react-i18next";
//Google Analytics Intergration
import ReactGA from "react-ga";
import GotCode from "./components/auth/GotCode";
import ChangePassword from "./components/auth/Changepassword";
import Footer from './components/common/Footer'
import { isEverit, isNorthwell } from "./components/common/check-org";
import { useLocation } from 'react-router-dom';

const TRACKING_ID = process.env.REACT_APP_GA_TID; //Google Analytics Tracking ID


ReactGA.initialize(TRACKING_ID);
function App() {
  const [showPrintPage, setShowPrintPage] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.user.loading);
  const user = useSelector((state) => state?.user?.userData?.user);
  const queryClient = useQueryClient();
  const location = useLocation();
  var url = new URL(window.location.href);
  var token = url?.searchParams.get("token");
  let access = url?.searchParams.get("access");
  let orgID = url?.searchParams.get("orgID");
  let lang = url?.searchParams.get("lang");

  if (token && access === "ok" && orgID) {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("access", access);
    sessionStorage.setItem("lang", lang);

    sessionStorage.removeItem("view");
    sessionStorage.removeItem("skillSectionName");
    sessionStorage.removeItem("contentType");
    sessionStorage.removeItem("subSkillID");
    sessionStorage.removeItem("skillSectionID");
  } else {
    access = sessionStorage.getItem("access");
  }

  sessionStorage.setItem("lang", (lang || "en"));
  // const dataLoading = useSelector(state => state.user.loading)
  // const isError = useSelector(state => state.user.error)
  const { mutate: newEnroll } = useMutation(newEnrollment, {
    onSuccess: (response) => {
      dispatch(setLoading(true));
      queryClient.invalidateQueries("fetching-all-data");
    },
    onError: (error) => { },
  });

  /*----------------------------------------------------------------
      Fetching All Data
  -------------------------------------------------------------------*/
  const { isLoading: adminDataLoading } = useQuery(
    ["fetching-all-data", { OrganizationId: orgID }],
    () => adminEnrolledData({ OrganizationId: orgID }),
    {
      enabled: Boolean(access === "ok" && orgID),
      onSuccess: async (response) => {
        dispatch(setData(response));
        dispatch(setLoading(false));
      },
    }
  );

  const { isLoading: orgLoading, data: orgData } = useQuery(
    "get-organizations",
    getOrganizations,
    {
      enabled: isAuthenticated(localStorage.getItem("token")),
      onSuccess: async (response) => {
        dispatch(setOrganization(response?.data));
      },
    }
  );

  const { data: notificationData } = useQuery(["get-notifications", user?.OrganizationId], () => getNotifications(user?.OrganizationId), {
    enabled: isAuthenticated(localStorage.getItem("token")),
    onSuccess: (response) => {
      dispatch(setNotifications(response?.notifications));
    },
  })

  const { isLoading: dataLoading, data: allData } = useQuery(
    "fetching-all-data",
    getAllData,
    {
      enabled: Boolean(access !== "ok"),
      onSuccess: async (response) => {
        dispatch(setData(response));
        dispatch(setLoading(false));
        dispatch(setOrganization(orgData?.data));
        if (isAuthenticated(localStorage.getItem("token"))) {
          if (!response?.data[0]?.isEnrolled) {
            newEnroll();
          } else {
            dispatch(setLoading(false));
          }
        }
      },
    }
  );

  /*----------------------------------------------------------------
      Sending Data to Redux
  -------------------------------------------------------------------*/
  // useEffect(() => {
  //   if (!dataLoading && !!allData.length && loading ) {
  //     dispatch(setLoading(false))
  //   }
  // }, [allData, dataLoading])

  /*-------------------------------------------------------------------
      AOS initialization for animations and Admin previews initalization
  ---------------------------------------------------------------------*/
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    handleAdminPreview();
    AOS.init({
      offset: 100,
      delay: 100,
      duration: 1000,
    });
  }, []);

  /*--------------------------------------------------------------------------------
      Handling previews when admin views, adds or edits content type from admin app
  ---------------------------------------------------------------------------------*/
  const handleAdminPreview = () => {
    const url = new URL(window.location.href);
    const view = url?.searchParams?.get("view");
    const subSkillID = url?.searchParams?.get("subSkillID");
    const skillSectionID = url?.searchParams?.get("skillSectionID");
    const skillSectionName = url?.searchParams?.get("skillSectionName");
    const contentType = url?.searchParams?.get("contentType");
    const adminToken = url?.searchParams?.get("adminToken");

    if (view && subSkillID && skillSectionID) {
      sessionStorage.setItem("view", view);
      sessionStorage.setItem("subSkillID", subSkillID);
      sessionStorage.setItem("skillSectionID", skillSectionID);
      sessionStorage.removeItem("skillSectionName");
      sessionStorage.removeItem("contentType");
      sessionStorage.removeItem("adminToken");
      sessionStorage.setItem("adminToken", adminToken);
      return;
    } else if (view && skillSectionName && contentType) {
      sessionStorage.setItem("view", view);
      sessionStorage.setItem("skillSectionName", skillSectionName);
      sessionStorage.setItem("contentType", contentType);
      sessionStorage.removeItem("subSkillID");
      sessionStorage.removeItem("skillSectionID");
      sessionStorage.setItem("adminToken", adminToken);
      return;
    } else if (view && subSkillID) {
      sessionStorage.setItem("view", view);
      sessionStorage.setItem("subSkillID", subSkillID);
      return;
    }
    // sessionStorage.removeItem("view")
    // sessionStorage.removeItem("subSkillID")
    // sessionStorage.removeItem("skillSectionID")
    // sessionStorage.removeItem("skillSectionName")
    // sessionStorage.removeItem("contentType")
    // sessionStorage.removeItem("adminToken")
  };

  const { t } = useTranslation();
  const printPage = () => {
    window.print({
      pageSetup: {
        size: "legal",
      },
      backgrounds: true,
      backgroundGraphics: true,
    });
  };
  console.log("Pathname: ", location.pathname);

  if (dataLoading || loading || adminDataLoading || orgLoading)
    return <Loading />;
  /*--------------------------------------------------------------------------------
      Main retun for routes
  ---------------------------------------------------------------------------------*/
  return (
    <>
      {
        !(isEverit(user?.OrganizationId) || isNorthwell(user?.OrganizationId)) && location.pathname !== "/login" &&
        <Tutorial orgID={user?.OrganizationId} />
      }
      <div style={{ ...printPageStyle, width: showPrintPage ? 80 : 30 }}>
        <Button
          onMouseEnter={() => setShowPrintPage(true)}
          onMouseLeave={() => setShowPrintPage(false)}
          style={btnStyle}
          onClick={() => printPage()}
          startIcon={<PrintIcon />}
        >
          {t("Print Page")}
        </Button>
      </div>
      <Toaster position="top-center" reverseOrder={false} />
      {/* {window.name === "Error" && isAuthenticated(sessionStorage.getItem("token")) ? navigate("/error") : ""} */}
      <Routes>
        {/* <Route exact path="/loade" element={<><Loading /> </>}></Route> */}
        <Route exact path="/got-a-code" element={<><GotCode /></>} ></Route>
        {/* <Route exact path="/code-register" element={<><CodeRegister /></>} ></Route>
        <Route exact path="/request-code" element={<><RequestCode /></>} ></Route> */}
        <Route
          exact
          path="/full-register"
          element={
            <>
              <FullRegister />
            </>
          }
        ></Route>
        <Route
          exact
          path="/clever-auth"
          element={
            <>
              <CleverAuth />
            </>
          }
        ></Route>
        <Route
          exact
          path="/email-verification/:id"
          element={
            <>
              <EmailVerification />
            </>
          }
        ></Route>
        <Route
          exact
          path="/reset-password"
          element={
            <>
              <ResetPassword />
            </>
          }
        ></Route>
        <Route
          exact
          path="/change-password"
          element={
            <>
              <ChangePassword />
            </>
          }
        ></Route>
        <Route
          exact
          path="/login"
          element={
            <>
              <Login />
              <Footer page={"login"} />
            </>
          }
        ></Route>

        {/* <Route exact path="/module" element={<><Module /></>} ></Route> */}
        <Route
          exact
          path="/module"
          element={
            <>
              <Modules />
              {
                isEverit(user?.OrganizationId) &&
                <Footer />
              }
            </>
          }
        ></Route>

        <Route
          exact
          path="/profile"
          element={
            <>
              <Profile />
            </>
          }
        ></Route>
        <Route
          exact
          path="/"
          element={
            <>
              <PreviewCheck />
            </>
          }
        ></Route>
        <Route
          exact
          path="/get-started"
          element={
            <>
              <GetStarted />
            </>
          }
        ></Route>
        <Route
          exact
          path="/welcome"
          element={
            <>
              <Wellcome />
            </>
          }
        ></Route>
        <Route
          exact
          path="/learn-more"
          element={
            <>
              <LearnMore />
            </>
          }
        ></Route>

        <Route
          exact
          path="/turn-phone-v"
          element={
            <>
              <TurnPhoneV />
            </>
          }
        ></Route>
        <Route
          exact
          path="/turn-phone-h"
          element={
            <>
              <TurnPhoneH />
            </>
          }
        ></Route>
        <Route
          exact
          path="/customer-support"
          element={
            <>
              <CustomerSupport />
            </>
          }
        ></Route>
        <Route
          exact
          path="/help-desk"
          element={
            <>
              <HelpDesk />
            </>
          }
        ></Route>
        <Route
          exact
          path="/privacy-policy"
          element={
            <>
              <PrivacyPolicy />
            </>
          }
        ></Route>
        <Route
          exact
          path="/success-skills-intro"
          element={<SuccessSkillsIntro />}
        ></Route>
        <Route
          exact
          path="/success-skills-form"
          element={<SuccessSkillForm />}
        ></Route>
        <Route
          exact
          path="/success-skill-search/:jobID/:skillData"
          element={<SuccessSkillSearch />}
        ></Route>
        <Route
          exact
          path="/success-skill-list/:jobID/:skillData"
          element={<SuccessSkillList />}
        ></Route>
        <Route
          exact
          path="/success-skill-details/:id"
          element={<SuccessSkillDetails />}
        ></Route>
        <Route exact path="/error" element={<Error />}></Route>

        <Route
          exact
          path="/module-detail/:id"
          element={
            <>
              <BusinessFoundation />
            </>
          }
        ></Route>

        <Route exact path="/wordscape" element={<WordsCape />}></Route>
        <Route exact path="/altspace-vr" element={<AltSpaceVR />}></Route>
        <Route exact path="/altspace-vrws" element={<AltSpaceVRWS />}></Route>
        <Route exact path="/lesson" element={
          <>
            <Lesson />
            {
              isEverit(user?.OrganizationId) &&
              <Footer />
            }
          </>
        }></Route>
        <Route exact path="/skills" element={
          <>
            <Subskills />
            {/* {
              isEverit(user?.OrganizationId) &&
              <Footer />
            } */}
          </>
        }></Route>
        <Route exact path="/skill-detail" element={<SkillsDetails />}></Route>
        <Route
          exact
          path="/skill-detail-assess"
          element={<SkillAssess />}
        ></Route>
        <Route exact path="/skill-detail-sims" element={<SkillSims />}></Route>
        <Route exact path="/skill-detail-quiz" element={<SkillQuiz />}></Route>
        <Route exact path="/quiz-result" element={<QuizResult />}></Route>
        <Route exact path="/rewards" element={<Rewards />}></Route>

        {/* <Route exact path="/newsubskill" element={<Skills />}></Route> */}
        {/* <Route exact path="/chatbot" element={<ChatBot />}></Route> */}
        <Route exact path="/video" element={<Video />}></Route>

        <Route exact path="/sticky" element={<Sticky />}></Route>
        <Route exact path="/sticky-demo" element={<StickyDemo />}></Route>
        <Route exact path="/planner" element={<Planner />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </>
  );
}

export default App;

const printPageStyle = {
  position: "fixed",
  zIndex: 9999,
  bottom: "300px",
  right: 0,
  transition: "all 0.5s ease-in-out",
};
const btnStyle = {
  color: "#616ded",
  width: "fit-content",
  height: "fit-content",
  fontSize: "6px",
  fontWeight: 700,
  textTransform: "capitalize",
  padding: 10,
  background: "#fff",
  boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1)",
};